export default "__VITE_PUBLIC_ASSET__206ba1f7__"